var validators = {
    positiveIntegerExcluding0: function (value) {
        return value === undefined || Number.isInteger(value) && value > 0;
    },
    positiveIntegerIncluding0: function (value) {
        return value === undefined || Number.isInteger(value) && value >= 0;
    },
    itemsPerSlide: function (value) {
        return value === undefined || value === 'auto' || this.positiveIntegerExcluding0(value);
    },
    layoutVariant: function (value) {
        return this.itemsPerSlide(value === null || value === void 0 ? void 0 : value.itemsPerSlide)
            && this.positiveIntegerIncluding0(value === null || value === void 0 ? void 0 : value.itemsPerSlideAutoWidth);
    },
};

export { validators };
